import React from "react";
import UpdateMedia from "./UpdateMedia";
import { useParams } from "react-router-dom";

export function DisplayMedia(props) {
    const params = useParams();
    return <UpdateMedia param={params} {...props} />
}
